import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import IconsState from "components/IconsState";

const IconsCell: FC<Props> = ({ element, keys, onDownload, onPreview }) => {
  return (
    <div className={styles.icons}>
      <IconsState
        onDownload={onDownload}
        onPreview={onPreview}
        keys={keys}
        msg={element}
        showStatus={false}
        keepIconPlace={true}
        showThreadIcon={true}
      />
    </div>
  );
};

export default IconsCell;
